import { render, staticRenderFns } from "./BlogDivider.vue?vue&type=template&id=3a0ce3c0"
import script from "./BlogDivider.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogDivider.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports